import { reactive, onMounted, onUnmounted } from "vue";

export function useWindowSize() {
    const windowSize = reactive({
        width: 0,
        height: 0,
    });

    function handleResize() {
        windowSize.width = window.innerWidth;
        windowSize.height = window.innerHeight;
    }

    onMounted(() => {
        window.addEventListener("resize", handleResize);
        handleResize(); // Initialize size
    });

    onUnmounted(() => {
        window.removeEventListener("resize", handleResize);
    });

    return windowSize;
}
